export const saloon1ImageOptions = {
  angle: 'saloon1',
  staticOptions: {
    Veneer: 1,
    Floorboard: 1,
    Worktop: 1,
    Fabric: 1,
    Handrail: 1,
    Layout: 1,
    BerthInfill: 1,
    FabricCabins: 1,
    AftCabinShelving: 1,
    SeaBerths: 1,
    Mast: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: null
    },
    {
      option: 'Floorboard',
      dependency: 'Layout'
    },
    {
      option: 'Worktop',
      dependency: 'Layout'
    },
    {
      option: 'Fabric',
      dependency: 'Worktop'
    },
    {
      option: 'Handrail',
      dependency: 'Veneer'
    },
    {
      option: 'FabricCabins',
      dependency: 'BerthInfill'
    },
    {
      option: 'Mast',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XP55/views/saloon1.js